import { CATEGORY_ICONS } from "./constants";
import { normalizeCategory } from "./categoryHelpers";
import { HelpCircle } from 'lucide-react';

export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const CURRENCY_SYMBOLS = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  JPY: "¥",
  CAD: "CA$",
  AUD: "A$",
  CHF: "Fr",
  CNY: "¥",
  INR: "₹",
  MXN: "MX$",
  BRL: "R$",
  SGD: "S$",
  VND: "₫",
  KRW: "₩",
};

export const formatAmount = (amount, currency = "USD") => {
  const num = parseFloat(amount) || 0;
  const symbol = CURRENCY_SYMBOLS[currency] ?? currency;
  return `${symbol}${num.toFixed(2)}`;
};

export const getCategoryIcon = (category) => {
  if (!category) return HelpCircle;
  return CATEGORY_ICONS[normalizeCategory(category)] || HelpCircle;
};
